import { render, staticRenderFns } from "./O_Peremeshenie.vue?vue&type=template&id=7cce5894&scoped=true&"
import script from "./O_Peremeshenie.vue?vue&type=script&lang=js&"
export * from "./O_Peremeshenie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cce5894",
  null
  
)

export default component.exports